import React from "react";
import { NumericFormat } from "react-number-format";
import PropTypes from "prop-types";
import styles from "./CommonInputDecimal.module.css";

/**
 * Input reutilizável para valores decimais
 */
function CommonInputDecimal({
  label,
  id,
  value,
  onChange,
  required = false,
  disabled = false,
  ...props
}) {
  return (
    <>
      {label && (
        <>
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
        </>
      )}
      <NumericFormat
        value={value}
        className={`${styles.input}`}
        name={id}
        id={id}
        displayType={"input"}
        thousandSeparator={"."}
        decimalSeparator={","}
        onValueChange={disabled ? () => {} : onChange}
        allowNegative={false}
        isNumericString={true}
        decimalScale={2}
        fixedDecimalScale={true}
        disabled={disabled}
        {...props}
      />
    </>
  );
}

CommonInputDecimal.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CommonInputDecimal;
